import { Box } from "@mui/material";
import { useTu } from "@src/appV2/i18n/useTu";
import { forwardRef } from "react";

interface NavigationMenuItemsWrapperTabletProps {
  children: React.ReactNode;
}

export const NavigationMenuItemsWrapperTablet = forwardRef<
  HTMLDivElement,
  NavigationMenuItemsWrapperTabletProps
>((props, ref) => {
  const { tu } = useTu("navigation");
  const { children } = props;

  return (
    <Box
      ref={ref}
      aria-label={tu("Navigation menu")}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        flex: 1,
        width: "108px",
        flexShrink: 0,
        gap: 0.5,
        paddingY: 2,
        paddingX: 2,
        overflowY: "auto",
        maskImage:
          "linear-gradient(to bottom, transparent, black 16px, black calc(100% - 16px), transparent)",
      }}
    >
      {children}
    </Box>
  );
});

NavigationMenuItemsWrapperTablet.displayName = "NavigationMenuItemsWrapperTablet";
